// @mui
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import { ListItem, ListItemAvatar } from '@mui/material';
// hooks
// components
import { AccountDto } from '../../../api';
// types

// ----------------------------------------------------------------------

type Props = {
  row: AccountDto;
  onViewRow: VoidFunction;
};

export default function SubAccountTableRow({ row, onViewRow }: Props) {
  const { fullName, profileImageUrl, email } = row;

  return (
    <ListItem onClick={onViewRow}>
      <ListItemAvatar>
        <Avatar alt={fullName} src={profileImageUrl} sx={{ mr: 2 }} />
      </ListItemAvatar>
      <ListItemText
        primary={fullName}
        secondary={email}
        primaryTypographyProps={{ typography: 'body2' }}
        secondaryTypographyProps={{ component: 'span', color: 'text.disabled' }}
      />
    </ListItem>
  );
}
